import { render } from "./ToDoSelectUser.vue?vue&type=template&id=453ca9a4&ts=true"
import script from "./ToDoSelectUser.vue?vue&type=script&lang=ts"
export * from "./ToDoSelectUser.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__